module.exports = __webpack_public_path__ + "img/dealer.893a4435.png";